module.exports = __webpack_public_path__ + "files/d4392d03f77d83225c323c684b28491c.png";